import { render } from "./healthPlan.vue?vue&type=template&id=0f7db671&scoped=true"
import script from "./healthPlan.vue?vue&type=script&lang=js"
export * from "./healthPlan.vue?vue&type=script&lang=js"

import "./healthPlan.vue?vue&type=style&index=0&id=0f7db671&lang=less&scoped=scoped"
import "./healthPlan.vue?vue&type=style&index=1&id=0f7db671&lang=less"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7db671"]])

export default __exports__